export const Spinner = (h) => (props) => (h("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", "aria-hidden": "true", viewBox: "0 0 24 24" }, h("path", { d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2" })));
//# sourceMappingURL=Spinner.js.map
